// src/pages/Study.js
import React from 'react';
import ButtonLink from '../components/Button';
const Study = () => {
  return (
    <div className="page study-page">
      <section className="page-header">
        <div className="container">
          <h1>Study</h1>
          <p>Past exams and contact for study matters</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          {/* Past exams */}
          <div className="info-card mb-2">
            <h3>Past exams & resources</h3>
            <p>
              Many student organisations keep archives of past exams and course material. These are
              a useful tool for revising and understanding the kinds of questions that are usually asked.
            </p>

            <ul className="documents-list">

              <li className="documents-item">
                <ButtonLink href="https://helsinkifi.sharepoint.com/:f:/s/Integralis/Ei6m_ADwNu5Fmq-GJ2UM-xgBgcdwnoPXnkTI6jkt7WqF7A">
                  All subjects – Integralis resources
                </ButtonLink>
              </li>
              <li className="documents-item">
                <ButtonLink href="https://cdn.jsdelivr.net/gh/integralis-ry/site_binaries@latest/documents/2026_Study_Guide_period_2.pdf">                
                  Period II study guide - Integralis (pdf)
                </ButtonLink>
              </li>
              <li className="documents-item">
                <ButtonLink href="https://tarpisto.tko-aly.fi/archive">
                  Computer science – TKO-äly archive
                </ButtonLink>
              </li>

              <li className="documents-item">
                <ButtonLink href="https://wiki.helsinki.fi/xwiki/bin/view/mathstatOpiskelu/Etusivu/Tenttiarkisto/">
                  Mathematics – Faculty exam archive
                </ButtonLink>
              </li>

              <li className="documents-item">
                <ButtonLink href="https://drive.google.com/drive/folders/0B1sm7iLrjMjcZEZYUjlhUDczb1E?resourcekey=0-zBdsrWGD8ZkubYv99BH57Q">
                  Physics – Resonanssi resources
                </ButtonLink>
              </li>

              <li className="documents-item">
                <ButtonLink href="https://www.matrix-ry.fi/tenttiarkisto">
                  Mathematics – Matrix archive
                </ButtonLink>
              </li>

              <li className="documents-item">
                <ButtonLink href="https://drive.google.com/drive/folders/1alOLibFnQxBp9OGwiJe2i84VQIksFax0">
                  Chemistry – HYK resources
                </ButtonLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="info-card">
            <h3>Contact student representatives</h3>
            <p>
              Do you want a course to be translated into English? Do you want a new course to be
              added? Have you had problems with a lecturer or course grading?
            </p>

            <p>
              You can submit your wishes and concerns to the degree programme&apos;s steering group.
              They will raise the issue anonymously with the faculty in their monthly meetings.
            </p>

            <p><strong>Steering group contact form:</strong></p>

            <p>
              <ButtonLink href="https://forms.office.com/e/9zn4XbGYzn">
                Steering group form
              </ButtonLink>
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Study;